// extracted by mini-css-extract-plugin
module.exports = {"neutral":"alert_neutral__nYbpM","error":"alert_error__r7JNh","success":"alert_success___psgp","warning":"alert_warning__HRivW","warning-train":"alert_warning-train__J0svj"};